<div class="file-preview bg-pays-subtle">
  <div class="row align-items-center">
    <button
      type="button"
      class="col btn-reset pe-0"
      (click)="onViewReceipt()">
      <div class="row align-items-center">
        <div class="col-auto">
          <img
            [ngSrc]="fileTypeIcon() ?? ''"
            height="34"
            width="25"
            alt="file icon" />
        </div>
        <div class="col fw-semibold">Uploaded receipt</div>
        <div class="col-auto">
          <div class="btn-action bg-none">
            <i class="text-secondary pays-svg-icon ic-eye"></i>
          </div>
        </div>
      </div>
    </button>
    <div class="col-auto ms-auto">
      <a
        rel="noopener"
        target="_blank"
        class="btn-action bg-none"
        [href]="conditionalEnvUrl()">
        <i class="iconoir-download"></i>
      </a>
      @if (!hideDelete()) {
        <button
          type="button"
          class="btn-action bg-none"
          (click)="onUploadNewReceipt()">
          <i class="pays-icon ic-bin size-1"></i>
        </button>
      }
    </div>
  </div>
</div>
